import React from "react";
import {
  CircleCharCompany,
  LineDashedChart,
  LineDashedChartCompanyAverage,
  LineDashedChartCompanySuccess,
} from "../../ContainerChart";

function CompanyInsights() {
  return (
    <div className="w-full flex flex-col gap-6">
      <div className="flex self-stretch justify-start items-start flex-row gap-6">
        <div className="flex flex-1 justify-start items-start flex-row gap-6 ">
          <div className="flex flex-1 justify-start items-start flex-col bg-[#FDFDFD] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
            <div className="flex self-stretch justify-start items-start flex-col gap-0.5">
              <div className="flex self-stretch justify-start items-center flex-row gap-4 pt-3 pb-2 px-[20px]">
                <p className="flex-1 text-[#181D27] text-sm  font-semibold">
                  Avg. Time to Hire
                </p>
              </div>
              <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                <div className="flex self-stretch justify-start items-start flex-col gap-5 p-[20px] rounded-xl">
                  <div className="flex self-stretch justify-start items-start flex-col md:flex-row gap-4">
                    <div className="flex flex-1 justify-start items-start flex-col gap-2">
                      <div className="flex self-stretch justify-start items-center flex-row gap-3">
                        <span className="text-[#181D27] text-3xl  font-semibold">
                          2 Weeks
                        </span>
                        <div className="flex justify-start items-center flex-row gap-1 py-0.5 pr-2 pl-1.5 bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-md shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M3.5 8.5L8.5 3.5M8.5 3.5H3.5M8.5 3.5V8.5"
                              stroke="#17B26A"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                          <span className="text-[#414651] text-sm  text-center font-medium">
                            2.4%
                          </span>
                        </div>
                      </div>
                    </div>
                    {/* <div className="flex justify-start items-start flex-row gap-3">
                      <div className="flex justify-start items-center flex-row gap-0.5 bg-[#FAFAFA] border-solid border-[#E9EAEB] border rounded-lg">
                        <div className="flex justify-center items-center flex-row gap-2 py-2 px-3 bg-[#FFFFFF] border-solid border-[#D5D7DA] border rounded-lg shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)] h-[36px]">
                          <span className="text-[#414651] text-sm  font-semibold">
                            12 months
                          </span>
                        </div>
                        <div className="flex justify-center items-center flex-row gap-2 py-2 px-3 rounded-lg h-[36px]">
                          <span className="text-[#717680] text-sm  font-semibold">
                            30 days
                          </span>
                        </div>
                        <div className="flex justify-center items-center flex-row gap-2 py-2 px-3 rounded-lg h-[36px]">
                          <span className="text-[#717680] text-sm  font-semibold">
                            7 days
                          </span>
                        </div>
                        <div className="flex justify-center items-center flex-row gap-2 py-2 px-3 rounded-lg h-[36px]">
                          <span className="text-[#717680] text-sm  font-semibold">
                            24 hours
                          </span>
                        </div>
                      </div>
                    </div> */}
                  </div>
                </div>

                <div className="w-full px-5">
                  <LineDashedChartCompanyAverage />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className=" w-full">
        {/* gap-6 grid md:grid-cols-3 grid-cols-2 */}
        {/* <div
          className=" md:col-span-1 col-span-2 flex w-full justify-start items-start flex-col bg-[#FDFDFD] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)] "
          //   style={{ width: "451px" }}
        >
          <div className="flex self-stretch justify-start items-start flex-col gap-0.5 h-full">
            <div className="flex justify-start items-center flex-row gap-4 pt-3 pb-2 px-[20px]">
              <p className="flex-1 text-[#181D27] text-sm  font-semibold">
                Active now
              </p>
            </div>
            <div className="h-[100%] w-full justify-center items-center bg-[#FFFFFF] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
              <CircleCharCompany />
            </div>
          </div>
        </div> */}

        <div className="flex  justify-start items-start flex-row gap-6 w-full col-span-2">
          <div className="flex flex-1 justify-start items-start flex-row gap-6">
            <div className="flex flex-1 justify-start items-start flex-col bg-[#FDFDFD] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
              <div className="flex self-stretch justify-start items-start flex-col gap-0.5">
                <div className="flex self-stretch justify-start items-center flex-row gap-4 pt-3 pb-2 px-[20px]">
                  <p className="flex-1 text-[#181D27] text-sm  font-semibold">
                    Candidate success rate
                  </p>
                </div>
                <div className="flex self-stretch justify-start items-start flex-col bg-[#FFFFFF] border-solid border-[#E9EAEB] border rounded-xl shadow-[_0px_1px_2px_0px_rgba(10,13,18,0.05)]">
                  <div className="w-full px-5">
                    <LineDashedChartCompanySuccess />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CompanyInsights;
